import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';
import '../../App.css';

const Login = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const { login } = useContext(AuthContext);
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        const result = await login(email, password);

        if (result.success) {
            const roleName = result.user.role_details?.name;
            if (roleName === 'SUPER_ADMIN' || result.user.is_superuser) {
                navigate('/');
            } else {
                navigate('/clinica/pos');
            }
        } else {
            setError(result.error);
        }
    };

    return (
        <div style={{ display: 'flex', minHeight: '100vh', width: '100vw', margin: 0, padding: 0 }}>
            <style>
                {`
                @media (max-width: 768px) {
                    .login-image-side { display: none !important; }
                    .login-form-side { width: 100% !important; flex: none !important; padding: 1rem !important; }
                }
                @media (max-width: 480px) {
                    .login-card {
                        padding: 2rem 1.5rem !important;
                        border-radius: 20px !important;
                        max-width: 100% !important;
                        box-shadow: 0 10px 30px rgba(62, 39, 35, 0.12) !important;
                    }
                    .login-logo {
                        height: 80px !important;
                        margin-bottom: 12px !important;
                    }
                    .login-title {
                        font-size: 1.6rem !important;
                        margin-bottom: 4px !important;
                    }
                    .login-subtitle {
                        font-size: 0.95rem !important;
                        margin-bottom: 24px !important;
                    }
                    .login-field {
                        margin-bottom: 16px !important;
                    }
                    .login-field-last {
                        margin-bottom: 28px !important;
                    }
                    .elegant-input {
                        padding: 13px 16px !important;
                        font-size: 0.95rem !important;
                    }
                    .elegant-btn {
                        padding: 13px !important;
                        font-size: 1rem !important;
                    }
                    .login-footer {
                        font-size: 0.78rem !important;
                        margin-top: 18px !important;
                    }
                }
                .elegant-input {
                    width: 100%;
                    padding: 16px 20px;
                    border-radius: 16px;
                    border: 1.5px solid var(--border-color);
                    font-size: 1rem;
                    background-color: var(--surface-color);
                    transition: all 0.3s ease;
                    outline: none;
                    box-sizing: border-box;
                }
                .elegant-input:focus {
                    border-color: var(--primary-color);
                    background-color: #ffffff;
                    box-shadow: 0 0 0 4px rgba(62, 39, 35, 0.1);
                }
                .elegant-btn {
                    width: 100%;
                    padding: 16px;
                    font-size: 1.15rem;
                    font-weight: 700;
                    border-radius: 16px;
                    background-color: var(--primary-color);
                    color: #fff;
                    border: none;
                    cursor: pointer;
                    transition: all 0.3s ease;
                    box-shadow: 0 8px 20px rgba(62, 39, 35, 0.2);
                }
                .elegant-btn:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 12px 25px rgba(62, 39, 35, 0.3);
                    background-color: var(--primary-hover);
                }
                `}
            </style>
            


            {/* Lado del Formulario */}
            <div 
                className="login-form-side"
                style={{ 
                    flex: 1, 
                    display: 'flex', 
                    alignItems: 'center', 
                    justifyContent: 'center',
                    backgroundColor: 'var(--background-color)',
                    padding: '2rem',
                    boxSizing: 'border-box',
                    overflowY: 'auto'
                }}
            >
                <div className="login-card" style={{ 
                    width: '100%', 
                    maxWidth: '540px', 
                    textAlign: 'center', 
                    backgroundColor: 'var(--surface-color)',
                    boxShadow: '0 25px 50px -12px rgba(62, 39, 35, 0.15)', 
                    padding: '4.5rem 4rem', 
                    borderRadius: '24px',
                    boxSizing: 'border-box'
                }}>
                    <img src={require('../../assets/logo.png')} alt="Biodentality" className="login-logo" style={{ width: '100%', maxHeight: '180px', marginBottom: '20px', objectFit: 'contain' }} />
                    <h2 className="login-title" style={{ color: 'var(--primary-color)', fontSize: '2.5rem', fontWeight: '800', marginBottom: '8px', letterSpacing: '-0.5px' }}>Iniciar Sesión</h2>
                    <p className="login-subtitle" style={{ marginBottom: '40px', color: 'var(--text-secondary)', fontSize: '1.2rem', fontWeight: '500' }}>Bienvenido al portal de Biodentality</p>

                    {error && <div className="alert alert-error" style={{ marginBottom: '25px', borderRadius: '12px', padding: '15px', backgroundColor: '#fee2e2', color: '#991b1b', border: '1px solid #f87171' }}>{error}</div>}

                    <form onSubmit={handleSubmit} style={{ textAlign: 'left' }}>
                        <div className="form-group login-field" style={{ marginBottom: '25px' }}>
                            <label htmlFor="email" style={{ fontWeight: '700', color: 'var(--primary-color)', marginBottom: '10px', display: 'block', fontSize: '1rem', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Correo Electrónico</label>
                            <input
                                type="email"
                                id="email"
                                className="elegant-input"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                                placeholder="tu@email.com"
                            />
                        </div>

                        <div className="form-group login-field-last" style={{ marginBottom: '45px' }}>
                            <label htmlFor="password" style={{ fontWeight: '700', color: 'var(--primary-color)', marginBottom: '10px', display: 'block', fontSize: '1rem', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Contraseña</label>
                            <input
                                type="password"
                                id="password"
                                className="elegant-input"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                                placeholder="••••••••"
                            />
                        </div>

                        <button type="submit" className="elegant-btn">
                            Ingresar
                        </button>
                        <div className="login-footer" style={{ marginTop: '25px', textAlign: 'center', color: 'var(--text-secondary)', fontSize: '0.85rem', fontWeight: '500' }}>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default Login;
